import { Limits } from '@studio/models/device';
import type { Device } from '@studio/models/device';
import { forwardRef } from 'react';
import { Viewer } from '../viewer/index.js';
import type { Props } from './types.js';
import { Editable } from '#~/common/card/index.js';
import type { Behavior } from '#~/common/card/index.js';

/** Video `<Card>` component. */
export const Card = forwardRef<Behavior, Props>(
  ({ device, handler, isCollapsed, ...props }, forwardedRef) => {
    // ENG-4406: show the settings gear on transitory credential placeholders
    // too — the previous no-gear state was the inconsistency this fixes. Only
    // `canControl` gates it now, matching every other device. Dropping the
    // placeholder term also re-enables double-click-rename on placeholders
    // (Rename is already reachable via the menu, so this is intended).
    // Per `reference-rules-in-comments` (ai.knowledge/global).
    return (
      <Editable<Device>
        forwardedRef={forwardedRef}
        handler={handler}
        item={device}
        maxLength={Limits.maxNameLength}
        settings={!props.canControl ? false : undefined}
        {...props}
      >
        {!isCollapsed && <Viewer className='rounded-t-4' deviceId={device.id} />}
      </Editable>
    );
  }
);
